class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      // On page load, if Shopify pre-filled the input with our enhanced query (e.g. "lp-e6*"),
      // strip the trailing * so the customer sees the clean term they originally typed.
      const currentVal = this.input.value;
      if (currentVal.endsWith('*') && currentVal !== '*') {
        const cleanVal = currentVal.slice(0, -1);
        this.input.value = cleanVal;

        // Also clean the * from any visible status text and page title
        document.querySelectorAll('[role="status"]').forEach(el => {
          if (el.textContent.includes(currentVal)) {
            el.textContent = el.textContent.replaceAll(currentVal, cleanVal);
          }
        });
        if (document.title.includes(currentVal)) {
          document.title = document.title.replaceAll(currentVal, cleanVal);
        }
      }

      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  onFormSubmit(event) {
    const query = this.input.value.trim();

    if (query === '') {
      // Empty search: show newest products
      this.input.value = '*';

      let sortInput = this.input.form.querySelector('input[name="sort_by"]');
      if (!sortInput) {
        sortInput = document.createElement('input');
        sortInput.type = 'hidden';
        sortInput.name = 'sort_by';
        this.input.form.appendChild(sortInput);
      }
      sortInput.value = 'created-descending';

      let typeInput = this.input.form.querySelector('input[name="type"]');
      if (!typeInput) {
        typeInput = document.createElement('input');
        typeInput.type = 'hidden';
        typeInput.name = 'type';
        this.input.form.appendChild(typeInput);
      }
      typeInput.value = 'product';
    } else if (!query.endsWith('*')) {
      // Append wildcard to broaden search results.
      // This forces Shopify to match partial product names/model numbers.
      // e.g. "lp-e6" becomes "lp-e6*" which matches LP-E6, LP-E6N, LP-E6NH, LP-E6P, etc.
      this.input.value = query + '*';
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
